import { styled } from '@mui/material';

import { getAssetPath } from '@/constants/configs';

export const Clock = styled(props => (
  <img
    src={getAssetPath('/bg-time-desktop.png')}
    alt="clock-icon"
    aria-hidden="true"
    {...props}
  />
))(({ theme }) => ({
  height: 'auto',
  width: '100%',
  maxWidth: 425,
  marginTop: theme.spacing(8),
}));
